'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeEnvironmentConfig = undefined;

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var storeEnvironmentConfig = exports.storeEnvironmentConfig = function storeEnvironmentConfig(config) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.INITIALIZE_CONFIG,
      config: config
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConfigActions.js
// module id = 627
// module chunks = 3 4